import { render } from "./BfPledgeBanner.vue?vue&type=template&id=5a5122d2"
import script from "./BfPledgeBanner.vue?vue&type=script&lang=js"
export * from "./BfPledgeBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__